import { publicApi } from "./axiosConfig";

export async function fetchCategories() {
  const response = await publicApi.get("/api/v1/products/categories/");

  return response.data;
}